import React, { FC, memo } from 'react';
import classNames from 'classnames';

import FileIcon from '@zvuk-b2b/react-uikit/ui/icons/File';

import { TEXTS } from './texts';
import { InvoiceContentProps, InvoiceContentSize } from './types';

import styles from './index.module.scss';

const InvoiceContent: FC<InvoiceContentProps> = ({ className, size = InvoiceContentSize.MEDIUM }) => (
  <div
    className={classNames(styles.content, className, {
      [styles.contentSmall]: size === InvoiceContentSize.SMALL,
    })}>
    <FileIcon className={styles.icon} />
    <div className={styles.text}>{TEXTS.INVOICE_TEXT}</div>
  </div>
);

export default memo(InvoiceContent);
